




























































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import CpptListContent from "@/components/soap/CpptListContent.vue";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import SoapDokterSvc from "@/services/SoapRanapDokter";
import SoapPerawatSvc from "@/services/SoapRanapPerawat";
import Adime from "@/services/Adime";
import Readback from "@/services/Readback";
import Handover from "@/services/Handover";
import SvcCatatanPemberianObat from "@/services/CatatanPemberianObat";
import SvcRekonsiliasiObat from "@/services/RekonsiliasiObat";
import SvcDaftarRegisterPasien from "@/services/DaftarRegisterPasien";
import SvcAsesmenKeperawatanDewasa from "@/services/AsesmenAwalRanapKeperawatan";
import SvcAsesmenKeperawatanAnak from "@/services/AsesmenAwalRanapAnak";
import SvcAsesmenKeperawatanPerinatal from "@/services/AsesmenAwalRanapPerinatal";
import SvcAsesmenKeperawatanIntensif from "@/services/AsesmenKeperawatanIntensif";
import { AsesmenPendingDpjpRow } from "@/types/daftarRegisterPasien";
import {
  buildCpptList,
  filterCpptForVerif,
  fetchCpptSources,
  canVerifCppt,
  CpptEntry,
  VerifikasiMode
} from "@/utils/cpptVerif";

@Component({
  components: { CpptListContent },
  inject: {
    verifikasiTerkunciFn: {
      from: "isVerifikasiTerkunci",
      default: () => () => false
    }
  }
})
export default class VerifikasiTerpaduDialog extends Vue {
  @Prop({ required: true }) readonly register!: string | number;
  @Prop({ type: Boolean, default: false }) readonly isActive!: boolean;
  @Prop({ type: String, default: "ranap" }) readonly mode!: VerifikasiMode;

  verifikasiTerkunciFn!: () => boolean;

  get verifikasiTerkunci(): boolean {
    return this.verifikasiTerkunciFn();
  }

  get registerSiap(): boolean {
    const no = RegisterKunjungan.register?.no;
    return !!no && String(no) === String(this.register);
  }

  dialog = false;
  panels: number[] = [];

  cpptList: CpptEntry[] = [];
  cpoList: any[] = [];
  rekonList: any[] = [];
  asesmenList: AsesmenPendingDpjpRow[] = [];

  verifyingCppt = false;
  verifyingCpo = false;
  verifyingRekon = false;
  /** `<jenis>:<id>` baris yang sedang diverifikasi, null saat menganggur. */
  verifyingAsesmen: string | null = null;

  showVerifCppt = false;
  checking = false;
  recheckQueued = false;

  get stateUser() {
    return userModule.user;
  }

  get isDpjp() {
    return RegisterKunjungan.register?.dokter?.id == this.stateUser.id;
  }

  get registerId(): number {
    return parseInt(String(this.register));
  }

  get cpptBtnTitle() {
    const onlyHandover =
      this.cpptList.length > 0 &&
      this.cpptList.every(cppt => cppt.type === "handover");
    return onlyHandover ? "Terima" : "Verifikasi";
  }

  get cpoTitle() {
    return this.stateUser.profesi == "Perawat"
      ? "Obat High Alert dan LASA"
      : "Pemberian Obat";
  }

  get cpoHeaders() {
    const base: any = [
      { text: "No", value: "index", width: "50px" },
      { text: "Nama Obat", value: "obat", width: "250px" },
      { text: "Dosis Pemberian", value: "dosis", width: "150px" }
    ];
    if (this.stateUser.profesi == "Dokter") {
      base.push(
        { text: "Jadwal Pemberian", value: "jadwal", width: "150px" },
        { text: "Rute Pemberian", value: "rute", width: "150px" }
      );
    } else {
      base.push(
        { text: "Waktu Pemberian", value: "waktu_pemberian", width: "150px" },
        { text: "Nama Pemberi Obat", value: "pemberi.nama", width: "180px" }
      );
    }
    return base;
  }

  get rekonHeaders() {
    return [
      { text: "No", value: "index", width: "10px" },
      { text: "Kategori Rekonsiliasi", value: "kategori", width: "50px" },
      { text: "Unit Asal", value: "unit_asal", width: "70px" },
      { text: "Unit Tujuan", value: "unit_tujuan", width: "70px" },
      { text: "Nama Petugas", value: "apoteker", width: "100px" },
      { text: "Detail Obat", value: "detail_obat", width: "500px" }
    ];
  }

  get rekonHeadersDetail() {
    return [
      { text: "Nama Obat", value: "obat", width: "150px" },
      { text: "Regimen", value: "regimen", width: "100px" },
      { text: "dibawa", value: "dibawa", width: "75px" },
      { text: "dilanjut", value: "dilanjut", width: "75px" },
      { text: "Regimen Ranap/Pulang", value: "regimen_ranap", width: "100px" }
    ];
  }

  formatDate(date) {
    return date ? moment(date, "YYYY-MM-DD").format("DD MMMM YYYY") : "";
  }

  @Watch("isActive", { immediate: true })
  onActiveChanged(active: boolean) {
    if (active) {
      this.checkAll();
    } else {
      this.dialog = false;
    }
  }

  @Watch("register")
  onRegisterChanged() {
    if (this.isActive) {
      this.checkAll();
    }
  }

  @Watch("isDpjp")
  onDpjpResolved(val: boolean) {
    if (val && this.isActive) {
      this.checkAll();
    }
  }

  @Watch("registerSiap")
  onRegisterSiap(siap: boolean) {
    if (siap && this.isActive) {
      this.checkAll();
    }
  }

  @Watch("verifikasiTerkunci")
  onVerifikasiTerkunci(terkunci: boolean) {
    if (terkunci) {
      this.dialog = false;
    } else if (this.isActive) {
      this.checkAll();
    }
  }

  @Watch("dialog")
  onDialogChanged(open: boolean) {
    if (open) {
      this.$nextTick(() => this.bindCpptScroll());
    } else {
      this.showVerifCppt = false;
    }
  }

  async checkAll() {
    if (!this.registerId) return;
    if (!this.registerSiap || this.verifikasiTerkunci) {
      this.dialog = false;
      return;
    }
    if (this.checking) {
      this.recheckQueued = true;
      return;
    }
    this.checking = true;
    try {
      await Promise.all([
        this.fetchCppt(),
        this.fetchCpo(),
        this.fetchRekon(),
        this.fetchAsesmen()
      ]);
      if (
        this.totalAntrean > 0 &&
        this.isActive &&
        this.registerSiap &&
        !this.verifikasiTerkunci
      ) {
        this.panels = [0, 1, 2, 3];
        this.dialog = true;
      } else {
        this.dialog = false;
      }
    } finally {
      this.checking = false;
    }
    if (this.recheckQueued) {
      this.recheckQueued = false;
      if (this.isActive) {
        this.checkAll();
      }
    }
  }

  get totalAntrean(): number {
    return (
      this.cpptList.length +
      this.cpoList.length +
      this.rekonList.length +
      this.asesmenList.length
    );
  }

  get asesmenHeaders() {
    return [
      { text: "No", value: "index", width: "40px" },
      { text: "Jenis Asesmen", value: "label" },
      { text: "Perawat", value: "perawat_nama" },
      { text: "Waktu Asesmen", value: "examined_at", width: "160px" },
      { text: "", value: "aksi", width: "110px", align: "end" }
    ];
  }

  get isModeRalan(): boolean {
    return this.mode === "ralan";
  }

  async fetchCppt() {
    try {
      const boleh = this.isModeRalan
        ? this.isDpjp
        : canVerifCppt(this.stateUser);
      if (!boleh) {
        this.cpptList = [];
        return;
      }
      await fetchCpptSources(this.registerId, this.stateUser, this.mode);
      this.cpptList = filterCpptForVerif(
        buildCpptList(this.stateUser),
        this.stateUser,
        this.isDpjp,
        this.mode
      );
    } catch (e) {
      this.cpptList = [];
    }
  }

  async fetchCpo() {
    if (this.isModeRalan) {
      this.cpoList = [];
      return;
    }
    try {
      const resp =
        this.stateUser.profesi == "Dokter"
          ? await SvcCatatanPemberianObat.getVerifDokter(this.register)
          : await SvcCatatanPemberianObat.getVerifPerawat(this.register);
      this.cpoList = Array.isArray(resp) ? resp : [];
    } catch (e) {
      this.cpoList = [];
    }
  }

  async fetchRekon() {
    if (this.isModeRalan) {
      this.rekonList = [];
      return;
    }
    try {
      const resp = await SvcRekonsiliasiObat.getUnverif(this.register);
      this.rekonList = resp?.status === 1 ? resp.data : [];
    } catch (e) {
      this.rekonList = [];
    }
  }

  bindCpptScroll() {
    const box = this.$refs.cpptBox as HTMLElement;
    if (!box) return;
    box.scrollTop = 0;
    const evaluate = () => {
      this.showVerifCppt =
        box.clientHeight === box.scrollHeight ||
        box.clientHeight + box.scrollTop >= box.scrollHeight - 50;
    };
    box.onscroll = evaluate;
    evaluate();
  }

  async verifCppt() {
    if (this.verifyingCppt || this.verifikasiTerkunci) return;
    this.verifyingCppt = true;
    try {
      await Promise.all(
        this.cpptList.map(async cppt => {
          if (!cppt) return;
          const now = moment().format("YYYY-MM-DD HH:mm:ss");

          if (cppt.type === "soap") {
            const SoapSvc =
              cppt.data.stat == "dr" ? SoapDokterSvc : SoapPerawatSvc;
            return SoapSvc.verify(cppt.data.id, {
              verificator_user_id: this.stateUser.id,
              verified_at: now
            });
          }

          if (cppt.type === "adime") {
            return Adime.verify(cppt.data.id, {
              verificator_user_id: this.stateUser.id,
              verified_at: now
            });
          }

          if (cppt.type === "readback") {
            if (
              !cppt.data.consultant_verified_at &&
              cppt.data.consultant_user_id == this.stateUser.id
            ) {
              await Readback.verifyByConsultant(cppt.data.id, {
                consultant_user_id: this.stateUser.id,
                consultant_verified_at: now
              });
            }
            if (this.isDpjp) {
              return Readback.verify(cppt.data.id, {
                dpjp_user_id: this.stateUser.id,
                dpjp_verified_at: now
              });
            }
          }

          if (cppt.type === "handover") {
            return Handover.approve(cppt.data.id);
          }
        })
      );
      await this.fetchCppt();
      this.closeIfDone();
    } finally {
      this.verifyingCppt = false;
    }
  }

  async verifCpo() {
    if (this.verifyingCpo || this.verifikasiTerkunci) return;
    this.verifyingCpo = true;
    try {
      const payload = { data: this.cpoList };
      const resp =
        this.stateUser.profesi == "Dokter"
          ? await SvcCatatanPemberianObat.VerifDokter(payload)
          : await SvcCatatanPemberianObat.VerifPerawat(payload);
      if (resp.status == 1) {
        appModule.NoticeDelay("Berhasil Verifikasi");
        await this.fetchCpo();
        this.closeIfDone();
      } else {
        appModule.sendErrorAlert(resp.message);
      }
    } finally {
      this.verifyingCpo = false;
    }
  }

  async verifRekon() {
    if (this.verifyingRekon || this.verifikasiTerkunci) return;
    this.verifyingRekon = true;
    try {
      const resp = await SvcRekonsiliasiObat.verif({ data: this.rekonList });
      if (resp.status === 1) {
        appModule.NoticeDelay("Berhasil Verifikasi");
        await this.fetchRekon();
        this.closeIfDone();
      } else {
        appModule.sendErrorAlert(resp.message);
      }
    } finally {
      this.verifyingRekon = false;
    }
  }

  closeIfDone() {
    if (this.totalAntrean === 0) {
      this.dialog = false;
    }
  }

  formatDateTime(value: string | null): string {
    return value ? moment(value).format("DD MMMM YYYY ~ HH:mm") : "-";
  }

  async fetchAsesmen() {
    if (this.isModeRalan || !this.isDpjp) {
      this.asesmenList = [];
      return;
    }
    try {
      this.asesmenList = await SvcDaftarRegisterPasien.getAsesmenPendingDpjp(
        this.registerId
      );
    } catch (e) {
      this.asesmenList = [];
    }
  }

  async verifAsesmen(item: AsesmenPendingDpjpRow) {
    if (this.verifyingAsesmen !== null || this.verifikasiTerkunci) return;

    this.verifyingAsesmen = `${item.jenis}:${item.id}`;

    const userId = this.stateUser.id;

    try {
      if (item.jenis === "dewasa") {
        await SvcAsesmenKeperawatanDewasa.verifyDpjp(item.id, userId);
      } else if (item.jenis === "anak") {
        await SvcAsesmenKeperawatanAnak.verifyDpjp(item.id, {
          dpjp_user_id: userId
        });
      } else if (item.jenis === "perinatal") {
        await SvcAsesmenKeperawatanPerinatal.verifyByDpjp(item.id, {
          dpjp_user_id: userId
        });
      } else {
        await SvcAsesmenKeperawatanIntensif.verifyDpjp(item.id, {
          dpjp_user_id: userId
        });
      }

      appModule.NoticeDelay("Berhasil Verifikasi");

      await this.fetchAsesmen();
      this.closeIfDone();
    } catch (e) {
      // 
    } finally {
      this.verifyingAsesmen = null;
    }
  }
}
